import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { catchError, throwError } from 'rxjs';

export class FillsEndpoints {
  private readonly http = inject(HttpClient);
  private env = inject<PIMSEnvironment>(ENVIRONMENT);

  post(mailOrderId: number, payload?: { response_id: number }) {
    return this.http
      .post<boolean>(`${this.env.constants.ADMIN_API_URL}/admin/mailorders/${mailOrderId}/fills`, payload)
      .pipe(catchError((err: HttpErrorResponse) => throwError(() => new Error(err.message))));
  }
}
